import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Button,
  Typography,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  demoModeState,
  inspStatusFilterState,
  queryOptionsState,
  imageDeleteEnabledState,
  tempFilterOptionState,
} from "../../recoil/index.ts";
import { formatDate, truncateString } from "../../utils/util.js";
import {
  KeyboardArrowUpIcon,
  KeyboardArrowDownIcon,
} from "../../icons/index.tsx";
import {
  getInspStatus,
  getInspStatusDetail,
  getInspStatusImage,
  updateReviewLabel,
  getNGLabels,
  getNGLabelCount,
  getOKRandomLabels,
  deleteInspStatusImage,
} from "../../services/inspectService.js";
import { toast } from "react-toastify";
import { DialogBottomStyle } from "../../utils/styleUtils.js";
import { convertEditDataSet, transFiles } from "../../utils/datasetFileUtil.js";
//TODO: 데이터셋 통합시 구현 마무리 필요
// import { addNewDataSet, editDataSetFileSetting } from "services/datasetService";
import {
  addNewDataSet,
  editDataSetFileSetting,
} from "../../services/datasetService.ts";
import { t } from "i18next";
import dayjs from "dayjs";
import ZoomBox from "../train/ZoomBox.js";
import ZoomController from "../train/ZoomController.js";
import InspStatusNGModal from "./InspStatusNGModal.js";

export default function InspStatusModal({
  uuid,
  setUuid,
  tableData,
  totalCount,
  pageData,
  setOpenModal,
}) {
  const [formData, setFormData] = useState([]);
  const [data, setData] = useState(tableData);
  const [imageSrc, setImageSrc] = useState(null);
  const [queryOption, setQueryOption] = useRecoilState(queryOptionsState);
  const [selectedPage, setSelectedPage] = useState(queryOption.page);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDataId, setCurrentDataId] = useState(uuid);
  const filterOption = useRecoilValue(inspStatusFilterState);
  const [demoMode, setDemoMode] = useRecoilState(demoModeState);
  const imageDeleteEnabled = useRecoilValue(imageDeleteEnabledState);
  const inspStatusQueryOption = useRecoilValue(tempFilterOptionState);
  const [isMakeButton, setIsMakeButton] = useState(false);
  const [ngReviews, setNgReviews] = useState([]);
  const [isMakeDataSetApply, setIsMakeDataSetApply] = useState(false);
  const [okRandomCount, setOkRandomCount] = useState(totalCount);
  const [okRandomLabels, setOkRandomLabels] = useState([]);
  const [isNGDataLoading, setIsNGDataLoading] = useState(false);
  const [ngCount, setNgCount] = useState("-");
  const [ngTarget, setNgTarget] = useState([]);
  const [ngCondition, setNgCondition] = useState(5);
  const [isFilter, setIsFilter] = useState(false);
  const [isOkLableLoading, setIsOkLableLoading] = useState(false);
  const [isFirstToast, setIsFirstToast] = useState(false);
  const [prevUuid, setPrevUuid] = useState(null);
  const [zoomMode, setZoomMode] = useState(false);
  const isKeyHandlingRef = useRef(false);
  const nowDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const dataSetFormat = {
    class_list: ["OK", "NG"],
    datasetType: "stsup-cls",
    description: `auto-generated dataset ${nowDate}`,
    files: [],
    labeled_count: [],
    material: `${filterOption?.material || ""}`,
    name: `${filterOption?.material || "temp"} ${nowDate}`,
    path: "",
    type: "stsup-cls",
  };
  const imageTimer = 500;

  useEffect(() => {
    console.log("pageData", pageData);
    setData(pageData.contents);
    setSelectedPage(queryOption.page);
  }, [pageData, currentDataId, filterOption]);

  useEffect(() => {
    if (filterOption.material) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, [filterOption]);

  useEffect(() => {
    let isMounted = true;
    let imageTimer;

    const fetchData = async () => {
      if (currentDataId) {
        try {
          const inspStatusData = await getInspStatusDetail(currentDataId);
          if (!isMounted) return;
          setFormData(inspStatusData.data);

          if (imageTimer) {
            clearTimeout(imageTimer);
          }

          imageTimer = setTimeout(async () => {
            if (!isMounted) return;

            try {
              const ImageResponse = await getInspStatusImage(
                inspStatusData.data.path
              );
              if (isMounted) {
                setImageSrc(ImageResponse);
              }
            } catch (error) {
              if (isMounted) {
                console.log(error);
              }
            }
          }, imageTimer);
        } catch (error) {
          if (isMounted) {
            console.log(error);
          }
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
      if (imageTimer) {
        clearTimeout(imageTimer);
      }
    };
  }, [currentDataId]);

  useEffect(() => {
    if (isFirstToast) return;
    if (ngCount >= ngCondition) {
      setIsFirstToast(true);
      toast.info(
        "충분한 NG 이미지가 수집되었습니다.\n 'Make DataSet' 버튼을 눌러 자동 데이터셋 생성이 가능합니다."
      );
    }
  }, [ngCount]);

  useEffect(() => {
    const hasAnyFilter = Object.values(inspStatusQueryOption).some(
      (value) => value !== null && value !== undefined
    );
    if (hasAnyFilter) {
      const fetchOKRandomLabels = async () => {
        try {
          setIsOkLableLoading(false);
          setOkRandomLabels([]);
          // OK 라벨 조회
          const response = await getOKRandomLabels(
            inspStatusQueryOption,
            okRandomCount
          );
          setIsOkLableLoading(true);
          setOkRandomLabels(response.data); // 미리 캐싱시킴

          // NG 라벨 개수 조회
          if (inspStatusQueryOption.material) {
            const ngData = await getNGLabelCount(inspStatusQueryOption);
            setNgCount(ngData.data.ngCount);
            setNgTarget(ngData.data.ngId);
          }
        } catch (error) {
          console.error("Error fetching OK random labels:", error);
        }
      };
      fetchOKRandomLabels();
    }
  }, [inspStatusQueryOption, okRandomCount]);

  const handleKeyDown = (event) => {
    if (isKeyHandlingRef.current) return;
    isKeyHandlingRef.current = true;
    if (event.key === "ArrowUp") {
      handlePrevious();
    }
    if (event.key === "ArrowDown") {
      handleNext();
    }
    if (event.key === "1") {
      if (!isFilter) return;
      handleReviewOK();
    }
    if (event.key === "2") {
      if (!isFilter) return;
      handleReviewNG();
    }
    setTimeout(() => {
      isKeyHandlingRef.current = false;
    }, 100);
  };

  useEffect(() => {
    if (isMakeButton) return;
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentDataId, isMakeButton, formData]);

  useEffect(() => {
    if (!isMakeDataSetApply) return;
    const makeAutoDataSet = async () => {
      try {
        const response = await addNewDataSet(dataSetFormat);
        const combinedData = [
          ...convertEditDataSet(ngReviews),
          ...convertEditDataSet(okRandomLabels),
        ];
        const classList = dataSetFormat.class_list;

        await editDataSetFileSetting(response.data.path, {
          class_list: classList,
          files: transFiles(combinedData),
        });
      } catch (error) {
        console.error("Error making auto dataset:", error);
      }
    };
    makeAutoDataSet();

    setIsMakeDataSetApply(false);
  }, [isMakeDataSetApply, dataSetFormat]);

  const getPreviosUuid = () => {
    if (!isLoading) {
      if (data && currentDataId) {
        const index = data.findIndex((item) => item.uuid === currentDataId);

        if (index > 0) {
          return data[index - 1].uuid;
        }
      }
    }

    return null;
  };

  const getNextUuid = () => {
    console.log("data", data);
    console.log("currentDataId", currentDataId);
    if (data && currentDataId) {
      const index = data.findIndex(
        //다음 uuid값이 현재 페이지의 데이터에 존재하는 경우
        (item) => item.uuid === currentDataId
      );
      // previous를 누르기 전의 data가 마지막 데이터가 아닌 경우
      if (index < data.length - 1) {
        return data[index + 1].uuid;
      }
    }
    setPrevUuid(currentDataId);
    return null;
  };

  const handlePrevious = async () => {
    const previousUuid = await getPreviosUuid();
    if (previousUuid) {
      setCurrentDataId(previousUuid);
      setUuid(previousUuid);
    } else {
      if (selectedPage !== 1) {
        const response = await getInspStatus({
          ...queryOption,
          ...filterOption,
          page: selectedPage - 1,
        });
        const arrayLength = response.data.contents.length;
        const lastIndex = arrayLength - 1;
        if (arrayLength !== 0) {
          setData(response.data.contents);
          setCurrentDataId(response.data.contents[lastIndex].uuid);
          setUuid(response.data.contents[lastIndex].uuid);
          setSelectedPage(selectedPage - 1);
        }
        setQueryOption((prev) => ({
          ...prev,
          page: selectedPage - 1,
        }));
      } else {
        toast.warning("마지막 데이터입니다.");
        return;
      }
    }
  };

  const handleNext = async () => {
    let nextUuid = await getNextUuid();
    console.log("nextUuid", nextUuid);
    if (nextUuid) {
      setCurrentDataId(nextUuid);
      setUuid(nextUuid);
    } else {
      const response = await getInspStatus({
        ...queryOption,
        ...filterOption,
        page: selectedPage + 1,
      });
      if (response.data.contents.length !== 0) {
        setData(response.data.contents);
        setCurrentDataId(response.data.contents[0].uuid);
        setUuid(response.data.contents[0].uuid);
        setSelectedPage(selectedPage + 1);
      } else {
        toast.warning("마지막 데이터입니다.");
        return;
      }
      setQueryOption((prev) => ({
        ...prev,
        page: selectedPage + 1,
      }));
    }
    nextUuid = null;
  };

  // 선택된 행 이미지 삭제
  const handleDeleteImage = async () => {
    try {
      let msg;
      const response = await deleteInspStatusImage(formData.path);
      msg = response.message;
      if (response.code === 0) {
        toast.success(msg);
      } else if (response.code === 3031) {
        toast.error(msg);
      } else {
        toast.error(msg);
      }
    } catch (error) {
      console.error("Error in handleDeleteImage:", error);
      toast.error("삭제 중 오류가 발생했습니다.");
    }
  };

  const handleReviewOK = async () => {
    if (formData.review === "OK") {
      return;
    }
    try {
      const response = await updateReviewLabel(currentDataId, "OK");
      setFormData((prev) => ({
        ...prev,
        review: "OK",
      }));
      setNgTarget((prev) => {
        if (prev.includes(currentDataId)) {
          setNgCount((count) => count - 1);
          return prev.filter((id) => id !== currentDataId);
        }
        return prev;
      });
      // toast.success(response.message);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleReviewNG = async () => {
    if (formData.review === "NG") {
      return;
    }
    try {
      const response = await updateReviewLabel(currentDataId, "NG");
      setFormData((prev) => ({
        ...prev,
        review: "NG",
      }));
      setNgCount((prev) => prev + 1);
      setNgTarget((prev) => [...prev, currentDataId]);
      // toast.success(response.message);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleMakeDataSet = async () => {
    setIsMakeButton(true);
    setIsNGDataLoading(false);
    try {
      const response = await getNGLabels(inspStatusQueryOption);
      setNgReviews(response.data);
      setIsNGDataLoading(true);
    } catch (error) {
      console.error("Error in handleMakeDataSet:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "800px",
        // height: "100%",
        width: "100%",
        flex: 1,
        background: "var(--row-color)",
      }}
    >
      <div className="insp-form-container" style={{ display: "flex" }}>
        {isLoading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "var(--text-color)" }} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "16px",
              height: "100%",
            }}
          >
            <div className="input-container">
              <Tooltip title={formData.name}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      color: "var(--text-color)",
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>[</span>
                    {formData.id}, {truncateString(formData.name, 25)}
                    <span style={{ marginLeft: "8px" }}>]</span>
                  </span>
                  {imageDeleteEnabled && (
                    <Button onClick={handleDeleteImage}>이미지 삭제</Button>
                  )}
                </Box>
              </Tooltip>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                }}
              >
                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">검사날짜</span>
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {truncateString(formatDate(formData.create_at))}
                  </span>
                </div>
                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">Client IP</span>
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {formData.client_ip}
                  </span>
                </div>
                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">Material Name</span>
                  {/* {demoMode ? (
                  <span className="custom-text"> ***</span>
                ) : ( */}
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {localStorage.getItem("demoMode") === "true"
                      ? "***"
                      : truncateString(formData.material_name, 15)}
                  </span>
                  {/* )} */}
                </div>
                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">Lot</span>
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {formData.lot}
                  </span>
                </div>
                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">Label</span>
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {truncateString(formData.label)}
                  </span>
                </div>

                <div
                  className="input-container"
                  style={{
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="modal-option-title">Review</span>
                  <span
                    className="custom-text"
                    style={{ color: "var(--text-color)" }}
                  >
                    {formData.review || ""}
                  </span>
                </div>

                {isFilter && (
                  <div
                    className="input-container"
                    style={{
                      paddingRight: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span className="modal-option-title">
                      NG<span style={{ fontSize: "12px" }}>(review)</span> /
                      Total
                    </span>
                    <span
                      className="custom-text"
                      style={{ color: "var(--text-color)" }}
                    >
                      {ngCount}
                      <span> / {totalCount}</span>
                    </span>
                  </div>
                )}
              </div>
              <div
                style={{
                  width: "1%",
                  borderRight: "solid 1px lightgray",
                }}
              ></div>
              <div
                style={{
                  width: "49%",
                  marginTop: "20px",
                  marginLeft: "5px",
                  height: "100%",
                }}
              >
                {imageSrc ? (
                  <ZoomBox
                    src={imageSrc}
                    zoom={2.5}
                    lensSize={220}
                    zoomMode={zoomMode}
                  />
                ) : (
                  /* <img
                  // src={imageSrc}
                  src={Z1Image}
                  alt="Inspection Status"
                  onError={(e) => {
                    e.target.src = noimg;
                  }}
                  width="100%"
                  height="100%"
                  style={{
                    filter:
                      localStorage.getItem("demoMode") === "true"
                        ? "blur(3px)"
                        : "none",
                    WebkitFilter:
                      localStorage.getItem("demoMode") === "true"
                        ? "blur(3px)"
                        : "none",
                  }}
                /> */
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <Box
        sx={{
          ...DialogBottomStyle,
          padding: "3px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            px: 2,
            pb: 1,
          }}
        >
          <Box>
            {!isFilter && (
              <Typography sx={{ fontSize: "14px", color: "gray" }}>
                ※자재 필터링 후 라벨링이 가능합니다.
              </Typography>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 7 }}>
            <div style={{ width: "100%" }}>
              <Button
                onClick={handleMakeDataSet}
                variant="outlined"
                disabled={!isFilter || ngCount < ngCondition}
              >
                {t("Make DataSet")}
              </Button>
              {/* {ngCount > 0 && (
                <span style={{ marginLeft: "4px", fontSize: "12px" }}>
                  {ngCount} NG
                </span>
              )} */}
            </div>
            <div
              style={{
                width: "40%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Tooltip title={"버튼 또는 키보드 1을 누르세요"} placement="top">
                <div style={{ marginRight: "5px" }}>
                  <Button
                    onClick={handleReviewOK}
                    variant="contained"
                    sx={{
                      backgroundColor: "var(--contained-btn-bg)",
                      color: "var(--contained-btn-color)",
                      "&:hover": {
                        backgroundColor: "var(--contained-btn-hover)",
                      },
                    }}
                    disabled={!isFilter}
                  >
                    OK
                  </Button>
                </div>
              </Tooltip>
              <Tooltip title="버튼 또는 키보드 2를 누르세요" placement="top">
                <div>
                  <Button
                    onClick={handleReviewNG}
                    variant="contained"
                    sx={{
                      backgroundColor: "var(--contained-btn-bg)",
                      color: "var(--contained-btn-color)",
                      "&:hover": {
                        backgroundColor: "var(--contained-btn-hover)",
                      },
                    }}
                    disabled={!isFilter}
                  >
                    NG
                  </Button>
                </div>
              </Tooltip>
            </div>
          </Box>
        </Box>
        <Box>
          <ZoomController zoomOn={zoomMode} setZoomOn={setZoomMode} />
          <IconButton style={{ marginRight: "3px" }} onClick={handlePrevious}>
            <KeyboardArrowUpIcon />
          </IconButton>
          <IconButton onClick={handleNext}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </Box>
      </Box>
      {isMakeButton && (
        <InspStatusNGModal
          open={isMakeButton}
          onClose={() => setIsMakeButton(false)}
          ngReviews={ngReviews}
          setNgReviews={setNgReviews}
          setNgCount={setNgCount}
          isMakeDataSetApply={isMakeDataSetApply}
          setIsMakeDataSetApply={setIsMakeDataSetApply}
          setFormData={setFormData}
          formData={formData}
          isNGDataLoading={isNGDataLoading}
          okRandomCount={okRandomCount}
          setOkRandomCount={setOkRandomCount}
          ngCondition={ngCondition}
          ngCount={ngCount}
          isOkLableLoading={isOkLableLoading}
          totalCount={totalCount}
          setOpenModal={setOpenModal}
        />
        // <></>
      )}
    </Box>
  );
}
